// extracted by mini-css-extract-plugin
export default {"row":"row-B__Az","topicContainer":"topicContainer-uo4Xn","titleContainer":"titleContainer-sVriW","title":"title-sQHC2"};